import { ChecklistItem } from '../types/ChecklistTypes';
import { ChecklistItemStatus } from '../types/ChecklistItemStatus.enum';

export interface NextUncheckedItem {
  currentIndex: number;
  index: number;
  item: ChecklistItem;
  wrapped: boolean;
}

/** `items` must be the ordered output of getVisibleItemsForSection, or hidden rows can be selected. */
export function findNextUncheckedItem(
  items: ChecklistItem[],
  currentItemId: string
): NextUncheckedItem | null {
  const currentIndex = items.findIndex(item => item.id === currentItemId);
  if (currentIndex === -1) return null;

  const isUnchecked = (item: ChecklistItem): boolean =>
    item.status === ChecklistItemStatus.Unchecked;

  const forwardIndex = items.findIndex(
    (item, index) => index > currentIndex && isUnchecked(item)
  );
  if (forwardIndex !== -1) {
    return {
      currentIndex,
      index: forwardIndex,
      item: items[forwardIndex],
      wrapped: false,
    };
  }

  const wrappedIndex = items.findIndex(
    (item, index) => index < currentIndex && isUnchecked(item)
  );
  return wrappedIndex === -1
    ? null
    : {
        currentIndex,
        index: wrappedIndex,
        item: items[wrappedIndex],
        wrapped: true,
      };
}
